import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { combineLatest, Subscription } from 'rxjs';
import * as fromRoot from '../../../core/store';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { STANDARD_FIELDS } from '../../../../../shared/fields/standard-fields';
import { AssetsImportSummaryModalComponent } from '../assets-import-summary-modal/assets-import-summary-modal.component';
import * as assetImportsActions from '../../../core/store/asset-imports/asset-imports.actions';

@Component({
    selector: 'ah-confirm-import',
    templateUrl: './confirm-import.component.html',
    styleUrls: ['./confirm-import.component.scss'],
    standalone: false
})
export class ConfirmImportComponent implements OnInit, OnDestroy {
    checking = false;
    importing = false;
    assetImportState;
    loading = true;
    fields: string[];
    importedFields: string[];
    valueExamples: { [assetImportsHeader: string]: string };
    subs;

    constructor(private route: ActivatedRoute, private router: Router, private store: Store<fromRoot.State>, public dialog: MatDialog) {

        this.fields = [STANDARD_FIELDS.name.name, STANDARD_FIELDS.department.name, STANDARD_FIELDS.sub_department.name,
            'Cost', STANDARD_FIELDS.quantity.name, STANDARD_FIELDS.description.name, STANDARD_FIELDS.vendor.name,
            'Char/Set Code', STANDARD_FIELDS.sub_code.name, STANDARD_FIELDS.wrap_box.name, STANDARD_FIELDS.free_field_1.name,
        STANDARD_FIELDS.free_field_2.name, STANDARD_FIELDS.free_field_3.name
        ];

        this.importedFields = ['Asset Name', 'Department Code (#)', 'Sub Department Code (#)',
            'Cost', 'Quantity', 'Description', 'Vendor', 'Character/Set Code', 'Sub Code',
            'Wrap Box', 'Free Field 1', 'Free Field 2', 'Free Field 3'];
    }

    ngOnInit(): void {
        combineLatest([
            this.store.select(fromRoot.getAssetImportsExamples),
            this.store.select(fromRoot.getAssetImportsState)])
            .subscribe(([assetsValueExamples, assetImportState]) => {
                this.valueExamples = assetsValueExamples;
                this.assetImportState = assetImportState;
                this.loading = false;
            });

        this.setupSubscriptions();
    }

    openImportSummary() {
        const data = { totalAssets: this.assetImportState.assetsCount };

        this.dialog.open(AssetsImportSummaryModalComponent, { data }).afterClosed().pipe(take(1)).subscribe(confirm => {
            if (confirm) {
                this.createAssetsFromImport();
            }
        });
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    onBack() {
        this.router.navigate(['../assets-import'], { relativeTo: this.route });
    }

    private createAssetsFromImport() {
        this.importing = true;
        this.dialog.closeAll();
        this.store.dispatch(new assetImportsActions.AddAssetsImportsAction(this.assetImportState));
    }

    private setupSubscriptions() {
        this.subs = new Subscription();

        const createdAssetSub = combineLatest([this.store.select(fromRoot.getAssetImportsCreateComplete), this.store.select(fromRoot.getAssetImportsCreateError)])
            .pipe(filter(([complete, _createError]) => complete))
            .subscribe(([_complete, createError]) => {
                if (!createError) {
                    this.router.navigate(['../'], { relativeTo: this.route, queryParams: { focus: 'review' } });
                } else {
                    this.importing = false;
                }
            });

        this.subs.add(createdAssetSub);
    }
}
